import React from 'react';
import ReactDOM from 'react-dom/client';
import { GoogleOAuthProvider } from '@react-oauth/google';
import App from './App';
import './assets/index.css';
import { registerServiceWorker } from './utils/serviceWorkerRegistration';
import { initDiagnosticLog } from './services/diagnosticLog';

// Diagnose-Log so früh wie möglich initialisieren (ADO #1231, Kriterium 7) - Fehler direkt
// beim App-Start (z.B. Auth-Cold-Start) sollen ebenfalls im Diagnose-Export landen.
initDiagnosticLog();

// Service Worker registrieren (für PWA und Offline-Funktionalität)
registerServiceWorker();

import { getEnv } from "./utils/env";

// Google Client ID aus Environment
const googleClientId = getEnv('VITE_GOOGLE_CLIENT_ID') || '';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={googleClientId}>
      <App />
    </GoogleOAuthProvider>
  </React.StrictMode>
);
